module.exports = __webpack_public_path__ + "static/media/6.bbd3c196.JPG";